import type { ReactNode } from "react";
import { SideMenu } from "../SideMenu";
import { AppBar } from "../AppBar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { ChatNotificationPanel } from "../ChatNotificationPanel";

interface LayoutProps {
  children: ReactNode;
}

const LayoutContent = ({ children }: LayoutProps) => {
  return (
    <div className="flex bg-background">
      <div className="sticky top-0 h-screen">
        <SideMenu />
      </div>
      <div className="flex flex-col flex-1 min-h-screen">
        <AppBar />
        <main className="flex-1">
          <div className="p-8">{children}</div>
        </main>
      </div>
      <ChatNotificationPanel />
    </div>
  );
};

export const Layout = ({ children }: LayoutProps) => {
  return (
    <SidebarProvider>
      <LayoutContent>{children}</LayoutContent>
    </SidebarProvider>
  );
};
